import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

export default class extends Controller {
    connect() {
        const context = this
        const element = context.element
        const additionalConfig = this.element.dataset.splide ? JSON.parse(this.element.dataset.splide) : {};

        if (element.dataset.gallery === "true") {

            const config = {
                lazyLoad: 'nearby',
                autoWidth: true,
                focus: 'left',
                speed: 1000,
                autoplay: true,
                ...additionalConfig,
            };

            this.splide = new Splide(this.element, config)
            this.splide.mount()

            context.thumbSplide = new Splide(element.querySelector(".thumbnails"), {
                lazyLoad: 'nearby',
                autoWidth: true,
                focus: 'center',
                speed: 1000,
                autoplay: false,
                gap: '-30px',
                pagination: false,
                arrows: false,
            })
            context.thumbSplide.mount()

            context.thumbnails(0);
            context.splide.on( 'active', function (activeSlide) {
                context.thumbnails(activeSlide.index);
            });

            context.splide.on( 'move', function () {
                context.moreSlidesCount();
            });
            context.splide.on( 'resized', function () {
                context.moreSlidesCount();
            });

            const observer = new MutationObserver((mutations, observer) => {
                context.moreSlidesCount();
            });
            observer.observe(this.element.querySelector('.thumbnails .splide__list'), {
                subtree: false,
                attributes: true
            });

            context.moreSlidesCount();
            return;
        }

        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            pagination: false,
            type: 'loop',
            speed: 1000,
            autoplay: true,
            ...additionalConfig,
        };

        this.splide = new Splide(this.element, config);
        this.splide.mount();
    }

    moreSlidesCount() {

        const more = this.element.querySelector(".thumbnail-more");
        if ( !more ) return;

        let invisibleSlides = 0;
        let startCount = false;
        this.element.querySelectorAll(".thumbnails .thumbnail").forEach(function(elm) {

            if (elm.classList.contains("is-visible")) {
                startCount = true;
            }

            if (startCount && !elm.classList.contains("is-visible")) {
                invisibleSlides++;
            }
        });

        more.querySelector("span").innerHTML = "+" + invisibleSlides;
        if (invisibleSlides === 0) {
            more.style.display = "none";
        } else {
            more.style.display = "block";
        }
    }

    thumbnails(index) {

        const context = this;
        context.thumbSplide.go(index)
        context.thumbSplide.on( 'click', function (activeSlide) {
            context.splide.go(activeSlide.index)
        });
    }
}
